export default "__VITE_ASSET__c3d4231c__"